import { ComputedRef, InjectionKey, Reactive } from 'vue';

import {
  EcosystemFieldMappings,
  EcosystemFieldsPush,
  IntegrationProfileType,
  PartnerAttributeFieldMappings,
  PartnerOption,
} from '@/types/integration_profiles';
import { EnabledTray, Mapping, TabValue } from '@/types/integrations';

export type BaseTrayState = {
  isEnabled: boolean;
  oppPush: boolean;
  customObjectPush: boolean;
  partnerFieldMappingsPush: boolean;
  partnerAttributesPush: boolean;
  accountPush: EcosystemFieldsPush;
  ecosystemMaps: EcosystemFieldMappings;
  partnerAttributes: PartnerAttributeFieldMappings;
  profileId?: string;
  partnerFieldMappings: Mapping[];
  sharedPartnerFields?: PartnerOption[];
};

export type FullTrayState = BaseTrayState & {
  isDeleting: boolean;
  isSaving: boolean;
  isSyncing: boolean;
  profileType?: IntegrationProfileType;
  saveTrayConfig: () => Promise<boolean>;
  savePartnerFieldMappings: () => Promise<void>;
  saveTabSettings: (activeTab: TabValue) => Promise<void>;
  enabledTray: ComputedRef<EnabledTray | undefined>;
  friendlyName: string;
  hasTrayConfigChanges: ComputedRef<boolean>;
  isAccountPushConfigValid: ComputedRef<boolean>;
  isPartnerFieldMappingsDirty: ComputedRef<boolean>;
  isProfileSettingDirty: boolean;
};

export type TrayState = Reactive<FullTrayState>;

export const ProvidedTrayState: InjectionKey<TrayState> = Symbol('TrayState');
